export const mapFrequencyToRunFields = (frequency) => {
  const frequencyMapping = {
    monday: { runMon: true },
    tuesday: { runTue: true },
    wednesday: { runWed: true },
    thursday: { runThu: true },
    friday: { runFri: true },
    saturday: { runSat: true },
    sunday: { runSun: true },

    firstMondayOfMonth: { runMon: true },
    firstTuesdayOfMonth: { runTue: true },
    firstWednesdayOfMonth: { runWed: true },
    firstThursdayOfMonth: { runThu: true },
    firstFridayOfMonth: { runFri: true },
    firstSaturdayOfMonth: { runSat: true },
    firstSundayOfMonth: { runSun: true },
    firstDayOfMonth: { runFirstOfMonth: true},
    lastDayOfMonth: { runLastOfMonth: true },

    firstDayOfQuarter: { runFirstOfQuarter: true },
    lastDayOfQuarter: { runLastOfQuarter: true },

    firstMondayOfYear: { runMon: true },
    firstTuesdayOfYear: { runTue: true },
    firstWednesdayOfYear: { runWed: true },
    firstThursdayOfYear: { runThu: true },
    firstFridayOfYear: { runFri: true },
    firstSaturdayOfYear: { runSat: true },
    firstSundayOfYear: { runSun: true },
    firstDayOfYear: { runFirstOfYear: true },
    lastDayOfYear: { runLastOfYear: true },
  };

  const runFields = initializeRunFields();

  if (frequency && frequencyMapping[frequency]) {
    Object.assign(runFields, frequencyMapping[frequency]);
  }
  return runFields;
};
export const initializeRunFields = () => ({
  runMon: false,
  runTue: false,
  runWed: false,
  runThu: false,
  runFri: false,
  runSat: false,
  runSun: false,
  runFirstOfMonth: false,
  runLastOfMonth: false,
  runFirstOfQuarter: false,
  runLastOfQuarter: false,
  runFirstOfYear: false,
  runLastOfYear: false,
})

const dayMap = {
  runMon: "Monday",
  runTue: "Tuesday",
  runWed: "Wednesday",
  runThu: "Thursday",
  runFri: "Friday",
  runSat: "Saturday",
  runSun: "Sunday",
};

// Returns the selected frequency day based on weekly/monthly/yearly frequency type
export const mapFrequency = (data) => {  
  if (!data || !data.runFrequency) return "";

  const capitalize = (str) => str[0].toUpperCase() + str.slice(1);

  // Get the day of the week based on the day flag in 'data'. 
  // Since day is common in some frequency types in weekly/monthly/yearly so fetch it one time only    
  const getDayKey = () => {
    for (const key in dayMap) {
      if (data[key]) return dayMap[key];
    }
    return null;
  };

  const day = getDayKey();

  // If monthly frequency then return the selected day of the month
  if (data.runFrequency === "monthly") {
    if (data.runFirstOfMonth) return "firstDayOfMonth";
    if (data.runLastOfMonth) return "lastDayOfMonth";
    if (data.runFirstOfQuarter) return "firstDayOfQuarter";
    if (data.runLastOfQuarter) return "lastDayOfQuarter";

    return day ? `first${capitalize(day)}OfMonth` : "";
  }

  // If yearly frequency then return the selected day of the year
  if (data.runFrequency === "yearly") {
    if (data.runFirstOfYear) return "firstDayOfYear";
    if (data.runLastOfYear) return "lastDayOfYear";

    return day ? `first${capitalize(day)}OfYear` : "";
  }

  // weekly (default fallback)
  return day ? day.toLowerCase() : "";
};

const parseCsvParam = value => {
  if (typeof value !== "string" || !value.trim()) {
    return [];
  }

  return [...new Set(value.split(",").map(item => item.trim()).filter(Boolean))];
};

const normalizeQueryString = reportParams => {
  if (typeof reportParams !== "string") {
    return "";
  }

  const trimmed = reportParams.trim();
  if (!trimmed) {
    return "";
  }

  return trimmed.startsWith("?") ? trimmed.slice(1) : trimmed;
};

export const parseScheduleFilterParams = reportParams => {
  const params = new URLSearchParams(normalizeQueryString(reportParams));

  return {
    projectId: params.get("projectGuid") || "All",
    partnerId: params.get("partnerGuid") || "All",
    projectIds: parseCsvParam(params.get("projectGuidsCsv")),
    partnerIds: parseCsvParam(params.get("partnerGuidsCsv")),
    apprenticeId: params.get("apprenticeGuid") || null,
    startDateFilter: params.get("dateFrom") || null,
    endDateFilter: params.get("dateTo") || null
  };
};

export const resolveMultiSelectOptionsFromParams = ({
  options = [],
  singleValue = "All",
  csvValues = [],
  allOptionValue = "All"
}) => {
  if (!Array.isArray(options) || options.length === 0) {
    return [];
  }

  const allOption = options.find(option => option?.value === allOptionValue) || null;
  const prioritizedValues = Array.isArray(csvValues) && csvValues.length > 0
    ? csvValues
    : singleValue && singleValue !== allOptionValue
      ? [singleValue]
      : [];

  const matchedOptions = prioritizedValues
    .map(value => options.find(option => option?.value === value))
    .filter(Boolean);

  if (matchedOptions.length > 0) {
    return matchedOptions;
  }

  if (singleValue === allOptionValue && allOption) {
    return [allOption];
  }

  return [];
};

export const syncSelectedMultiSelectOptions = ({
  currentValue = [],
  options = [],
  allOptionValue = "All"
}) => {
  if (!Array.isArray(currentValue) || currentValue.length === 0 || !Array.isArray(options) || options.length === 0) {
    return [];
  }

  const availableByValue = new Map(options.map(option => [option?.value, option]));
  const hasAllSelected = currentValue.some(option => option?.value === allOptionValue);

  if (hasAllSelected) {
    const allOption = availableByValue.get(allOptionValue);
    return allOption ? [allOption] : [];
  }

  return currentValue
    .map(option => availableByValue.get(option?.value))
    .filter(Boolean);
};
